import { RootState } from 'store';

const CalendarState = (state: RootState) => state.dashboard.calendar.calendar;

export const selectLoading = (state: RootState) => CalendarState(state).loading;
export const selectOptions = (state: RootState) => CalendarState(state).options;
export const selectParams = (state: RootState) => CalendarState(state).params;

export const selectDate = (state: RootState) => CalendarState(state).date;
export const selectViewType = (state: RootState) => CalendarState(state).viewType;
export const selectRangeType = (state: RootState) => CalendarState(state).rangeType;
